/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES 企業の管理画面用 API
 * PR TIMES 企業の管理画面で使うAPI。basePathは今後変わる事も想定している。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CurrentCompanyBasicInfo } from './CurrentCompanyBasicInfo';
import {
    CurrentCompanyBasicInfoFromJSON,
    CurrentCompanyBasicInfoFromJSONTyped,
    CurrentCompanyBasicInfoToJSON,
} from './CurrentCompanyBasicInfo';

/**
 * 
 * @export
 * @interface GetCurrentCompanyBasicInfoResponse
 */
export interface GetCurrentCompanyBasicInfoResponse {
    /**
     * status code (HTTPと同じ)
     * @type {number}
     * @memberof GetCurrentCompanyBasicInfoResponse
     */
    status: number;
    /**
     * 
     * @type {string}
     * @memberof GetCurrentCompanyBasicInfoResponse
     */
    message: string;
    /**
     * 
     * @type {CurrentCompanyBasicInfo}
     * @memberof GetCurrentCompanyBasicInfoResponse
     */
    data: CurrentCompanyBasicInfo;
}

/**
 * Check if a given object implements the GetCurrentCompanyBasicInfoResponse interface.
 */
export function instanceOfGetCurrentCompanyBasicInfoResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "message" in value;
    isInstance = isInstance && "data" in value;

    return isInstance;
}

export function GetCurrentCompanyBasicInfoResponseFromJSON(json: any): GetCurrentCompanyBasicInfoResponse {
    return GetCurrentCompanyBasicInfoResponseFromJSONTyped(json, false);
}

export function GetCurrentCompanyBasicInfoResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCurrentCompanyBasicInfoResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': CurrentCompanyBasicInfoFromJSON(json['data']),
    };
}

export function GetCurrentCompanyBasicInfoResponseToJSON(value?: GetCurrentCompanyBasicInfoResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': CurrentCompanyBasicInfoToJSON(value.data),
    };
}

